var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8666 132.493C10.5543 121.286 3.7011 107.337 1.13209 92.3262C-1.43692 77.315 0.387767 61.8812 6.38646 47.8829C12.3852 33.8846 22.3021 21.9186 34.9435 13.4254C47.5848 4.9323 62.4116 0.274129 77.6388 0.0117272C92.866 -0.250675 107.845 3.89388 120.771 11.9464C133.697 19.9989 144.021 31.6162 150.498 45.3995C156.976 59.1828 159.331 74.5446 157.281 89.6354C155.231 104.726 148.862 118.903 138.942 130.458L137.729 129.417C147.449 118.096 153.688 104.206 155.697 89.4203C157.706 74.6347 155.398 59.5837 149.052 46.0792C142.705 32.5748 132.591 21.1926 119.926 13.3029C107.261 5.4133 92.5855 1.35259 77.6664 1.60968C62.7472 1.86677 48.2204 6.43071 35.8348 14.752C23.4492 23.0733 13.7328 34.7973 7.85545 48.5124C1.97811 62.2275 0.190342 77.3491 2.70738 92.0567C5.22442 106.764 11.939 120.431 22.0426 131.411L20.8666 132.493Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter2);
export default __webpack_public_path__ + "static/media/center2.47d3eb88484bbf4b109a4c931dde29e6.svg";
export { ForwardRef as ReactComponent };